import React, { useState, useCallback } from 'react';
import { Send, CheckCircle2 } from 'lucide-react';

const EMPTY = { name: '', phone: '', class: '', subject: '', message: '' };
const CLASSES = ['Pre-KG / KG', 'Class 1-5', 'Class 6-8', 'Class 9-10', 'Class 11-12', 'Competitive Exam'];

function persistLocally(entry) {
  try {
    const prev = JSON.parse(localStorage.getItem('pikachu_enquiries') || '[]');
    prev.push({ ...entry, ts: new Date().toISOString() });
    localStorage.setItem('pikachu_enquiries', JSON.stringify(prev));
  } catch (err) {
    console.error('Failed to persist enquiry locally:', err);
  }
}

export default function ContactForm() {
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState(EMPTY);

  const upd = useCallback((k) => (e) => {
    const val = e.target.value;
    setForm((prev) => ({ ...prev, [k]: val }));
  }, []);

  const submit = useCallback((e) => {
    e.preventDefault();
    persistLocally(form);
    setSent(true);
    setTimeout(() => setSent(false), 5000);
    setForm(EMPTY);
  }, [form]);

  return (
    <div className="lg:col-span-7">
      <form onSubmit={submit} className="bg-[#FFF8EC] text-[#2C3E50] rounded-3xl border-2 border-[#F4B93E] p-6 lg:p-8 space-y-5">
        <div className="grid sm:grid-cols-2 gap-5">
          <div>
            <label className="text-xs font-black uppercase tracking-widest text-[#2C3E50]/70">Your name</label>
            <input required value={form.name} onChange={upd('name')} placeholder="e.g. Anjali Sharma" className="mt-1 w-full px-4 py-3 bg-white border-2 border-[#2C3E50] rounded-lg font-semibold placeholder:text-[#2C3E50]/40 focus:outline-none focus:ring-2 focus:ring-[#E64B2B]" />
          </div>
          <div>
            <label className="text-xs font-black uppercase tracking-widest text-[#2C3E50]/70">Phone number</label>
            <input required value={form.phone} onChange={upd('phone')} type="tel" placeholder="+91 98XXXXXXXX" className="mt-1 w-full px-4 py-3 bg-white border-2 border-[#2C3E50] rounded-lg font-semibold placeholder:text-[#2C3E50]/40 focus:outline-none focus:ring-2 focus:ring-[#E64B2B]" />
          </div>
          <div>
            <label className="text-xs font-black uppercase tracking-widest text-[#2C3E50]/70">Class</label>
            <select required value={form.class} onChange={upd('class')} className="mt-1 w-full px-4 py-3 bg-white border-2 border-[#2C3E50] rounded-lg font-semibold focus:outline-none focus:ring-2 focus:ring-[#E64B2B]">
              <option value="">Select class</option>
              {CLASSES.map((opt) => <option key={opt}>{opt}</option>)}
            </select>
          </div>
          <div>
            <label className="text-xs font-black uppercase tracking-widest text-[#2C3E50]/70">Subject</label>
            <input required value={form.subject} onChange={upd('subject')} placeholder="e.g. Maths, Science" className="mt-1 w-full px-4 py-3 bg-white border-2 border-[#2C3E50] rounded-lg font-semibold placeholder:text-[#2C3E50]/40 focus:outline-none focus:ring-2 focus:ring-[#E64B2B]" />
          </div>
        </div>
        <div>
          <label className="text-xs font-black uppercase tracking-widest text-[#2C3E50]/70">Message (optional)</label>
          <textarea rows="3" value={form.message} onChange={upd('message')} placeholder="Tell us about your requirement, preferred timings, etc." className="mt-1 w-full px-4 py-3 bg-white border-2 border-[#2C3E50] rounded-lg font-semibold placeholder:text-[#2C3E50]/40 focus:outline-none focus:ring-2 focus:ring-[#E64B2B]" />
        </div>
        <button type="submit" className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-lg bg-[#E64B2B] text-white font-black border-2 border-[#2C3E50] paper-shadow-sm hover:-translate-y-0.5">
          {sent ? (<><CheckCircle2 size={18} /> Enquiry received! We’ll call soon.</>) : (<>Send Enquiry <Send size={18} /></>)}
        </button>
        <p className="text-xs text-[#2C3E50]/60 text-center font-semibold">By submitting, you agree to be contacted by a Pikachu Classes counsellor.</p>
      </form>
    </div>
  );
}
